import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";

const dimensionsOptions = [
  { label: "Diameter", property: "diameter" },
  { label: "Arc Angle", property: "arcAngle" },
  { label: "Start Angle", property: "startAngle" },
];

type Props = {
  arcAngle: number;
  diameter: number;
  startAngle: number;
  isEditingRef: React.MutableRefObject<boolean>;
  handleInputChange: (property: string, value: string) => void;
};

const CurvatureSettings = ({
  arcAngle,
  diameter,
  startAngle,
  isEditingRef,
  handleInputChange,
}: Props) => {
  return (
    <section className="flex flex-col border-b border-borderColor px-2 py-5">
      <div className="flex flex-row gap-1 ">
        {dimensionsOptions.map((item) => (
          <div key={item.label} className="w-1/2">
            <h3 className="text-[10px] uppercase px-1 mb-2">{item.label}</h3>

            <div
              key={item.label}
              className="flex flex-1 items-center gap-2 rounded-sm"
            >
              <Input
                type="number"
                id={item.property}
                placeholder="100"
                value={
                  item.property === "diameter"
                    ? diameter
                    : item.property === "arcAngle"
                    ? arcAngle
                    : startAngle
                }
                className="input-ring bg-transparent text-white placeholder"
                min={0}
                onChange={(e) => {
                  handleInputChange(item.property, e.target.value);
                }}
                onBlur={(e) => {
                  isEditingRef.current = false;
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CurvatureSettings;
